module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrMedium.8e85e26.woff2";